import { render } from "./GeoDropdown.vue?vue&type=template&id=2c81b584&scoped=true"
import script from "./GeoDropdown.vue?vue&type=script&lang=js"
export * from "./GeoDropdown.vue?vue&type=script&lang=js"

import "./GeoDropdown.vue?vue&type=style&index=0&id=2c81b584&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c81b584"]])

export default __exports__